import { useEffect, useRef } from "react";

const GuestyWidget = () => {
  const containerRef = useRef(null);
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    // Load Guesty CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "https://s3.amazonaws.com/guesty-frontend-production/search-bar-production.css";
    link.media = "all";
    document.head.appendChild(link);

    // Load Guesty JS
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://s3.amazonaws.com/guesty-frontend-production/search-bar-production.js";
    script.async = true;
    script.onload = () => {
      try {
        if (window.GuestySearchBarWidget) {
          window.GuestySearchBarWidget.create({
            siteUrl: "kspaceproperties.guestybookings.com",
            color: "#ff8c00"
          }).catch((e) => console.log("[Guesty Widget]:", e.message));
        }
      } catch (e) {
        console.log("[Guesty Widget]:", e.message);
      }
    };
    document.body.appendChild(script);

    return () => {
      try { document.head.removeChild(link); } catch (e) {}
      try { document.body.removeChild(script); } catch (e) {}
    };
  }, []);

  return (
    <div data-testid="guesty-booking-widget" className="guesty-wrapper">
      <h3 className="text-2xl font-semibold text-[#1a4d2e] mb-6 text-center" style={{ fontFamily: 'var(--font-heading, Georgia, serif)' }}>
        Book Your Stay
      </h3>
      <div id="search-widget_IO312PWQ" ref={containerRef} />
      <p className="text-xs text-slate-500 text-center mt-4">You won't be charged yet</p>
    </div>
  );
};

export default GuestyWidget;
